// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"edit-off"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M17.9936 9.89339L21.0506 6.83635L17.1615 2.94727L14.1045 6.0043L17.9936 9.89339Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.0545 10.0544L4.78744 15.3215L3.99805 20L8.67652 19.2106L13.9436 13.9435M12.6094 7.5L17.1622 2.94727L21.0513 6.83635L16.4985 11.3891M17.9946 9.89348L14.1055 6.00439","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 4L10.0545 10.0545L13.9436 13.9436L20 20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const EditOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'edit-off',
    ref,
    icon: element,
  },
));

EditOffIcon.displayName = 'EditOffIcon';

export default EditOffIcon;
